import React from 'react';

const Sidebar = ({
  onFilterChange,
  categories = [],
  brands = [],
  priceRange = { min: '', max: '' },
  onPriceChange,
  disabled = false,
}) => {
  const handlePriceInput = (field) => (event) => {
    const rawValue = event.target.value || '';
    const sanitized = rawValue.replace(/[^0-9.,]/g, '');
    if (typeof onPriceChange === 'function') {
      onPriceChange(field, sanitized);
    }
  };
  
  return (
    <div className="bg-[#F9FAFB] border border-gray-200 p-4 rounded-md">
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">SHOP</h3>
        <div className="flex items-center">
          <input 
            type="text" 
            placeholder="€ min"
            className="border border-gray-300 rounded-md px-2 py-1 w-1/2 mr-2 text-sm"
            value={priceRange.min}
            onChange={handlePriceInput('min')}
            inputMode="decimal"
            aria-label="Minimum price"
            disabled={disabled}
          />
          <span>-</span>
          <input 
            type="text" 
            placeholder="€ max"
            className="border border-gray-300 rounded-md px-2 py-1 w-1/2 ml-2 text-sm"
            value={priceRange.max}
            onChange={handlePriceInput('max')}
            inputMode="decimal"
            aria-label="Maximum price"
            disabled={disabled}
          />
        </div>
      </div>
      
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">PRODUCT TYPE</h3>
        {categories.length === 0 ? (
          <p className="text-sm text-gray-500">Asnjë kategori në dispozicion.</p>
        ) : (
          <div className="space-y-2">
            {categories.map((category) => (
              <div key={category} className="flex items-center">
                <input
                  type="checkbox"
                  id={`category-${category}`}
                  className="mr-2"
                  onChange={(e) => onFilterChange('category', category, e.target.checked)}
                  disabled={disabled}
                />
                <label htmlFor={`category-${category}`} className="text-sm">{category}</label>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">BRANDS</h3>
        {brands.length === 0 ? (
          <p className="text-sm text-gray-500">Asnjë markë në dispozicion.</p>
        ) : (
          <div className="space-y-2">
            {brands.map((brand) => (
              <div key={brand} className="flex items-center">
                <input
                  type="checkbox"
                  id={`brand-${brand}`}
                  className="mr-2"
                  onChange={(e) => onFilterChange('brand', brand, e.target.checked)}
                  disabled={disabled}
                />
                <label htmlFor={`brand-${brand}`} className="text-sm">{brand}</label>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div>
        <h3 className="text-lg font-medium mb-2">BESTSELLERS</h3>
        <div className="space-y-2">
          <div className="flex items-center">
            <input type="checkbox" id="bestseller-5" className="mr-2" disabled={disabled} />
            <label htmlFor="bestseller-5" className="text-sm">5★</label>
          </div>
          <div className="flex items-center">
            <input type="checkbox" id="bestseller-4" className="mr-2" disabled={disabled} />
            <label htmlFor="bestseller-4" className="text-sm">4★</label>
          </div>
          <div className="flex items-center">
            <input type="checkbox" id="bestseller-3" className="mr-2" disabled={disabled} />
            <label htmlFor="bestseller-3" className="text-sm">3★</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;